import styled from "styled-components";

export const DeviceSelectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    height: 100%;

    .amap-info-content {
        background-color: rgba(0, 0, 0, 0.5);
        padding-right: 10px;
        z-index: 200;
    }

    .amap-info-sharp {
        border-top: 8px solid rgba(0, 0, 0, 0.2);
    }
`;

export const DeviceSelectionHeader = styled.div`
    flex: 0 0 auto;
    margin: 10px 0px;
    font-size: 18px;
`;

export const DeviceSelectionContent = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    width: 100%;
    height: 500px;
    gap: 20px;
`;

export const DeviceSelectionLeft = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const ToolBarWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0px 0px 20px 0px;
    padding: 0px 20px;
`;

export const SearchInputWrapper = styled.div`
    width: 300px;
`;

export const DeviceSelectionTableWrapper = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
`;

export const DeviceSelectionRight = styled.div`
    width: 45%;
`;

export const OperationWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin: 10px 0px;
`;



